import React from "react";

/**
 * Confetti — CSS-only confetti rain. Sits on top of the winner card.
 */
export default function Confetti() {
  const pieces = Array.from({ length: 18 });
  const colors = ["#F7768E", "#E0AF68", "#9ECE6A", "#7DCFFF", "#BB9AF7"];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {pieces.map((_, i) => (
        <span
          // index-based key is acceptable here: the array length is constant
          // and the pieces are visually interchangeable.
          key={`confetti-${i}`}
          className="absolute -top-2 block h-2 w-2 rounded-sm opacity-80"
          style={{
            left: `${(i / pieces.length) * 100}%`,
            background: colors[i % colors.length],
            animation: `mc-confetti ${2 + (i % 5) * 0.3}s ${i * 0.12}s linear infinite`,
            transform: "translateY(-100%)",
          }}
        />
      ))}
      <style>{`
        @keyframes mc-confetti {
          0%   { transform: translateY(-100%) rotate(0deg); opacity: 1; }
          100% { transform: translateY(140%) rotate(540deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
